import { render, staticRenderFns } from "./ExpensesDashboard.vue?vue&type=template&id=51746ba6&"
import script from "./ExpensesDashboard.vue?vue&type=script&lang=js&"
export * from "./ExpensesDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ExpensesDashboard.vue"
export default component.exports